import { EventEmitter, Injectable, Output } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";

@Injectable({
	providedIn: "root"
})
export class DeactivateGuard  {
	constructor() { }

	@Output() blockSite = new EventEmitter();

	canDeactivate(
		component: any,
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot,
		nextState?: RouterStateSnapshot
	) {
		if (!component.canDeactivate()) {
			const navigateTo = nextState ? nextState.url : "";

			this.blockSite.emit(navigateTo);
			return false;
		}

		return true;
	}
}
